import * as fs from "fs";
import * as ko from "knockout";
import { RNSAPI } from "../../api";
import { Utils } from "../../utils";
import { MainViewModel } from "../../main";
import '../dialog/dialog';
import { DialogViewModel } from '../dialog/dialog';

class AddressViewModel {
    types = ko.observableArray(["Mandant", "Gegner", "Sonstige"]);
    selectedType = ko.observable(this.types()[0]);

    //DisplayGVertreter1 = ko.observable(null);
    mandantData = ko.observable(true);

    typeChanged(obj, event) {
        if (event.originalEvent) {
            if (this.selectedType() === "Mandant") {
                this.mandantData(true);
            } else {
                this.mandantData(false);
            }
        }
    }


    IsEditMode = ko.observable(false);
    modalTitle = ko.observable("");
    modalKeys = ko.observableArray([]);
    modalColumns = ko.observableArray([]);
    modalData = ko.observableArray([]);
    modalHandleSelection: KnockoutObservable<(selectedObject: any) => void> = ko.observable();

    pickGeneric(title, keys, columns, data) {
        this.modalTitle(title);
        this.modalKeys(keys);
        this.modalColumns(columns);
        this.modalData(data);
    };

    async pickRechtsform(person) {
        let rechtsformen = (await RNSAPI.getRechtsformen()).Payload.LegalForms;
        this.pickGeneric("Rechtsform", ["NameID", "Briefanrede"], ["Name", "Anrede"], rechtsformen);
        this.modalHandleSelection((selectedObject) => {
          person.Rechtsform(selectedObject()["NameID"]);
          person.AnredeBriefkopf(selectedObject()["Briefanrede"]);
          person.AnredeDirekt(selectedObject()["Anrede"]);
        })
        $('#modal').modal('show');
    };

    async pickGVertreter(person) {
        let addresses = (await RNSAPI.getPersonsForScope(this.selectedType())).Payload.Addresses;
        this.pickGeneric("Gesetzlicher Vertreter", ["FirstName", "Name1", "CityName"], ["Vorname", "Nachname", "Ort"], addresses);
        this.modalHandleSelection((selectedObject) => {
            this.basicPerson().GesetzlicherVertreter1Id(selectedObject()["Keyword"]);
        });
        $('#modal').modal('show');
    };


    newBasicPerson() {
        let obj = {
            FirstName: ko.observable(""),
            Name1: ko.observable(""),
            Rechtsform: ko.observable(null),
            Address: ko.observable(null),
            ZipCode: ko.observable(null),
            CityName: ko.observable(null),
            EmailAddress: ko.observable(null),
            Phone1: ko.observable(null),
            AnredeBriefkopf: ko.observable(null),
            AnredeDirekt: ko.observable(null),
            Note1: ko.observable(null),
            GesetzlicherVertreter1Id: ko.observable(null),
            Fax: ko.observable(null),
            RSVersNr: ko.observable(null)

        };

        obj["Keyword"] = ko.computed(function () {
            return (obj.Name1() + obj.FirstName()).substring(0, 20);
        });

        return ko.observable(obj);
    };

    basicPerson = this.newBasicPerson();

    changeExtra() {
    };

    resetObject(obj) {
        for (let key in obj) {
            obj[key](null);
        }
    }

    currentPanelData = ko.observable({
        panel: 'mandant-template',
        data: self
    });

    mapping = {
        "mandant": {
            "panel": "mandant-template",
            "data": self
        },
        "gegner": {
            "panel": "gegner-template",
            "data": self
        },
        "sonstige": {
            "panel": "sonstige-template",
            "data": self
        }
    };

    goto(name) {
        this.currentPanelData(this.mapping[name]);
        this.currentPanelData.valueHasMutated();
    };

    async postData() {
        $(".form-group").each(function () { $(this).removeClass("has-error"); });
        if (!Utils.checkErrors(["Name1"], this.basicPerson(), "mandant", [Utils.checkString])) return;

        let person = ko.toJSON(this.basicPerson());

        if (this.IsEditMode()) {
            try {
                let result = await RNSAPI.updatePerson(this.basicPerson(), this.selectedType());
                if (result.Type === "UpdateSuccessful") {
                    MainViewModel.RoutingTable.showAddressOverview();
                } else {
                    alert("Fehler beim Speichern.");
                }
            } catch (e) {
                console.log(e);
                alert("Fehler beim Speichern: " + e.responseText);
            }
        } else {
            try {
                let result = await RNSAPI.createPerson(this.basicPerson(), this.selectedType());
                if (result.Type === "AdditionSuccessful") {
                    MainViewModel.RoutingTable.showAddressOverview();
                } else {
                    alert("Fehler beim Anlegen: Person mit diesem Keyword existiert bereits.");
                }
            } catch (e) {
                console.log(e);
                alert("Fehler beim Anlegen: " + e.responseText);
            }
        }
    };

    async loadPerson(keyword: string, type: string) {
        let result = (await RNSAPI.getPersonForKeyword(keyword, type));
        if (result.Type === "ExactMatchNotFound") {
            alert("Person wurde in der Zwischenzeit gelöscht!")
            return;
        }
        let person = result.Payload.Address;
        let newPerson = this.newBasicPerson();
        let obj = newPerson();
        for (let key in person) {
            if (obj[key] === undefined) {
                obj[key] = person[key];
            } else if (key !== "Keyword") {
                obj[key](person[key]);
            } else {
                obj["Keyword"] = ko.observable(person["Keyword"]);
            }
        }
        this.basicPerson(obj);
    }

    constructor(params: any) {
        this.selectedType.subscribe((newValue) => this.goto(newValue.toLowerCase()));

        params = params || {};
        let keyword = params.keyword;
        let type = params.type;
        this.IsEditMode(keyword !== undefined && type !== undefined);

        if (this.IsEditMode()) {
            this.loadPerson(keyword, type);
            this.selectedType(type);
        }
    }
}

let html = fs.readFileSync(__dirname + '/address.html', 'utf8');

ko.components.register("address-view", {
    viewModel: AddressViewModel,
    template: html
});
